<template>
	<div class="iv2-error__500">
		<div class="iv2-error__500-block">
			<h1 class="iv2-error__500-number">{{ $t('system.error.500') }}</h1>
			<h2 class="iv2-error__500-lead">{{ $t('system.error.lead') }}</h2>
			<p class="iv2-error__500-summary text-pre">{{ $t('system.error.summary') }}</p>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.iv2-error__500 {
	background-color: #efefef;
	height: 100vh;
	position: relative;

	.iv2-error__500-block {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;

		.iv2-error__500-number {
			font-size: 5.5rem;
		}

		.iv2-error__500-lead {
			font-size: 1.5rem;
			font-weight: 600;
			padding: 2rem 1rem;
			margin: 0;
		}

		.iv2-error__500-summary {
			margin: 0;
		}
	}
}

@media (max-width: 1199px) {
	.iv2-error__500 {
		.iv2-error__500-block {
			.iv2-error__500-lead {
				font-size: 1rem;
			}
		}
	}
}
</style>